// import React from "react";
// import Cavalli from "../imgs/Cavalli_Musica-removebg-preview.png";
// import Municipio4 from "../imgs/municipio_4-removebg-preview.png";
// import Municipio5 from "../imgs/municipio_5-removebg-preview.png";

// const Partners = () => {
//   return (
//     <div className="h-screen flex flex-col items-center z-10 xs:text-base md:text-xl bg-gradient-to-r from-white to-amber-50">
//       <p className="text-red-600 font-extrabold xs:text-2xl md:text-3xl ">
//         PARTNERS
//       </p>
//       <img src={Cavalli} className="mt-2" />
//       <img src={Municipio4} />
//       <img src={Municipio5} />
//     </div>
//   );
// };

// export default Partners;

import React from "react";
import Cavalli from "../imgs/Cavalli_Musica-removebg-preview.png";
import Municipio4 from "../imgs/municipio_4-removebg-preview.png";
import Municipio5 from "../imgs/municipio_5-removebg-preview.png";
import { GiThreeFriends } from "react-icons/gi";

const Partners = () => {
  const partners = [
    { img: Cavalli, alt: "Cavalli Musica" },
    { img: Municipio4, alt: "Municipio 4" },
    { img: Municipio5, alt: "Municipio 5" },
  ];

  return (
    <div className=" flex flex-col items-center justify-center bg-gradient-to-r from-white to-amber-50 px-4 md:px-16 pb-12">
      <GiThreeFriends className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        PARTNERS
      </h1>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 items-center justify-items-center w-full max-w-5xl z-10">
        {partners.map((partner, idx) => (
          <div
            key={idx}
            className="p-4 bg-white rounded-xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition duration-500 flex items-center justify-center"
          >
            <img
              src={partner.img}
              alt={partner.alt}
              className="max-h-40 md:max-h-48 object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
